import {
  Card,
  CardActionArea,
  CardContent,
  Fab,
  Typography,
  Zoom
} from '@material-ui/core';
import {
  createStyles,
  makeStyles,
  Theme,
  useTheme
} from '@material-ui/core/styles';
import { MailOutlineRounded } from '@material-ui/icons';
import ChevronRightIcon from '@material-ui/icons/ChevronRightRounded';
import EmojiObjectsIcon from '@material-ui/icons/EmojiObjectsOutlined';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { RootState } from '../app/store';
import plugAndPlayConfig from '../config/plugAndPlay';
import { ALL_MENU } from './../constants/menuTabs';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      margin: theme.spacing(3, 0, 10, 0)
    },
    menu: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      marginTop: theme.spacing(2)
    },
    card: {
      width: 360,
      margin: theme.spacing(1)
    },
    media__box: {
      display: 'flex',
      justifyContent: 'center'
    },
    media: {
      height: 200
    },
    header__menu: {
      display: 'flex',
      alignItems: 'center'
    },
    icon: {
      color: theme.palette.primary.main,
      display: 'flex',
      alignItems: 'center'
    },
    header__label: {
      flexGrow: 1,
      marginLeft: theme.spacing(2)
    },
    header__labelH2: {
      marginTop: theme.spacing(-1)
    },
    header__labelP: {
      marginBottom: theme.spacing(-0.5),
      lineHeight: '120%',
      wordWrap: 'break-word'
    },
    extendedIcon: {
      marginRight: theme.spacing(1)
    },
    actionIcon: {
      position: 'fixed',
      bottom: theme.spacing(3),
      right: theme.spacing(3),
      zIndex: 100,
      paddingRight: theme.spacing(3)
    }
  })
);

export default function Home() {
  const classes = useStyles();
  const theme = useTheme();
  const { user } = useSelector((state: RootState) => state.userProfile);
  const { t } = useTranslation();

  const transitionDuration = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };

  return (
    <div className={classes.root}>
      <Typography component="p" variant="h5">
        {t('home.greeting', { name: user?.firstName ?? '' })}
      </Typography>
      <Typography component="p" variant="subtitle2">
        {t('home.question')}
      </Typography>
      <div className={classes.menu}>
        {plugAndPlayConfig.filterMenuItems(ALL_MENU).filter(
          (menu) =>
            menu.isActive &&
            (!menu.permission ||
              user?.permissions.some(
                (permission) => permission === menu.permission
              ))
        ).map(({ label, feature, to, icon, src }) => (
          <Card className={classes.card} key={label}>
            <CardActionArea component={NavLink} to={to}>
              <div className={classes.media__box}>
                <img className={classes.media} src={src} alt={label} />
              </div>
              <CardContent>
                <div className={classes.header__menu}>
                  <div className={classes.icon}>{icon}</div>
                  <div className={classes.header__label}>
                    <Typography
                      className={classes.header__labelH2}
                      variant="h6"
                      component="h2"
                    >
                      {label}
                    </Typography>
                    <Typography
                      className={classes.header__labelP}
                      variant="caption"
                      component="p"
                      color="textSecondary"
                    >
                      {feature}
                    </Typography>
                  </div>
                  <ChevronRightIcon />
                </div>
              </CardContent>
            </CardActionArea>
          </Card>
        ))}
      </div>
      <Zoom
        in
        timeout={transitionDuration}
        style={{
          transitionDelay: `${transitionDuration.exit}ms`
        }}
        unmountOnExit
      >
        <Fab
          className={classes.actionIcon}
          onClick={() => {
            window.open(
              `${process.env.REACT_APP_REQUEST_FOR_BACKSPACE_WEB_URL}?systemName=doc`,
              '_blank'
            );
          }}
          variant="extended"
          color="primary"
          aria-label={t('home.requestNewUserAria') as string}
        >
          <MailOutlineRounded className={classes.extendedIcon} />
          {t('home.requestNewUser')}
        </Fab>
      </Zoom>
    </div>
  );
}
